import 'client-only';

import {
  DEAL_PACKAGE_ROUTE_CALLER_KIND_META_NAME,
  type DealPackageRouteCallerKind,
} from './constants';

const CALLER_KINDS = new Set<DealPackageRouteCallerKind>([
  'org_member',
  'outside_signer',
  'unknown',
]);

/**
 * Reads `caller_kind` stamped into the document by the deal layout (SSR).
 */
export function readDealPackageRouteCallerKindFromDocument():
  | DealPackageRouteCallerKind
  | undefined {
  if (typeof document === 'undefined') return undefined;
  const meta = document.querySelector(
    `meta[name="${DEAL_PACKAGE_ROUTE_CALLER_KIND_META_NAME}"]`
  );
  const content = meta?.getAttribute('content');
  if (content && CALLER_KINDS.has(content as DealPackageRouteCallerKind)) {
    return content as DealPackageRouteCallerKind;
  }
  return undefined;
}
